const PauseIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="9.5" y1="4.98437" x2="9.5" y2="19.0156" stroke="currentColor"/>
            <line x1="14.5625" y1="4.98437" x2="14.5625" y2="19.0156" stroke="currentColor"/>
        </svg>
    )
}

export default PauseIcon